import { memo, useMemo } from 'react';

import { CopyText, Flex, Label } from '@/components/core';
import { HowToGuide } from '@/components/flow';
import { useGetAppClientWithSecret } from '@/hooks';
import { useTriggerStore } from '@/store';

export type TriggerPowerAutomateConfigurationProps = object;

// eslint-disable-next-line no-empty-pattern
const ITriggerPowerAutomateConfiguration = ({}: TriggerPowerAutomateConfigurationProps) => {
  const action = useTriggerStore((state) => state.action);
  const { data: appClient } = useGetAppClientWithSecret();
  const clientCredentials = useMemo(
    () => (appClient?.clientSecret ? btoa(`${appClient.clientId}:${appClient.clientSecret}`) : undefined),
    [appClient]
  );

  return (
    <Flex col className="gap-md p-md grow">
      <Flex variant="plain" col className="p-md gap-4 rounded-lg border-1 border-gray-100 bg-white shadow-xs">
        <Flex col className="gap-xs">
          <Label>Client Credentials</Label>
          <CopyText isSensitive value={clientCredentials} />
        </Flex>
      </Flex>

      <div className="grow" />

      <HowToGuide actionId={action?.actionId} />
    </Flex>
  );
};

export const TriggerPowerAutomateConfiguration = memo(
  ITriggerPowerAutomateConfiguration
) as typeof ITriggerPowerAutomateConfiguration;
